import { getStatusBadgeClassName, getStatusBadgeLabel } from '@/lib/statusBadge';
import type { ContentStatus } from '../types/content.types';

export type { ContentStatus };

export const VALID_TRANSITIONS: Record<ContentStatus, ContentStatus[]> = {
  draft: ['submitted'],
  submitted: ['draft', 'under_review', 'rejected'],
  under_review: ['approved', 'rejected'],
  approved: ['published'],
  rejected: ['draft', 'submitted'],
  published: [],
};

export function getValidTransitions(currentStatus: ContentStatus): ContentStatus[] {
  return VALID_TRANSITIONS[currentStatus] || [];
}

export function isValidTransition(from: ContentStatus, to: ContentStatus): boolean {
  if (from === to) return true;
  return VALID_TRANSITIONS[from]?.includes(to) ?? false;
}

export const STATUS_LABELS: Record<ContentStatus, string> = {
  draft: getStatusBadgeLabel('draft'),
  submitted: getStatusBadgeLabel('submitted'),
  under_review: getStatusBadgeLabel('under_review'),
  approved: getStatusBadgeLabel('approved'),
  rejected: getStatusBadgeLabel('rejected'),
  published: getStatusBadgeLabel('published'),
};

export const STATUS_COLORS: Record<ContentStatus, string> = {
  draft: getStatusBadgeClassName('draft'),
  submitted: getStatusBadgeClassName('submitted'),
  under_review: getStatusBadgeClassName('under_review'),
  approved: getStatusBadgeClassName('approved'),
  rejected: getStatusBadgeClassName('rejected'),
  published: getStatusBadgeClassName('published'),
};
